export default __webpack_public_path__ + "static/media/schoenP.5e0adee7.jpg";